import { useState } from 'react';
import NoReports from '../../../common/components/noReport/noReport';
import FilterItems from '../reportFilters/filterItems';
import ReportTable from '../reportTable/reportTable';

const initialFilters = {
  reportType: null,
  page: 1,
  limit: 5,
  filterType: null,
  duration: null,
};
// eslint-disable-next-line react/prop-types
const GenerateReport = ({ page }) => {
  const [showTable, setShowTable] = useState({
    show: false,
    tableName: '',
    tableData: [],
    date: null,
    fromDate: null,
    toDate: null,
    totalResults: null,
    dynamicHeaders: [],
  });
  const [filters, setFilters] = useState(initialFilters);
  return (
    <>
      {!(showTable?.tableName === 'payOffReport' && showTable?.show) ? (
        <FilterItems
          setShowTable={setShowTable}
          page={page}
          setFilters={setFilters}
          filters={filters}
        />
      ) : null}
      {showTable.show ? (
        <ReportTable showTable={showTable} setShowTable={setShowTable} />
      ) : (
        <NoReports page={page} />
      )}
    </>
  );
};

export default GenerateReport;
